import { API_URL } from './http'
import http from './http'

export function getSocialProviders() {
  return http.get('auth/providers').then((res) => res.data)
}

export function socialRedirectUrl(provider) {
  const base = String(API_URL || '').replace(/\/?$/, '/')
  return `${base}auth/${provider}/redirect`
}

export function completeSocialRegistration(payload) {
  return http.post('auth/social/complete', payload).then((res) => res.data)
}

export function persistAuthSession(data = {}) {
  localStorage.setItem('access_token', data.token || '')
  localStorage.setItem('role', data.role || '')
  localStorage.setItem('company_role', data.company_role || 'admin')
  localStorage.setItem('can_manage_products', data.can_manage_products ? '1' : '0')
  localStorage.setItem('user_name', data.user_name || '')
  localStorage.setItem('sale_mode', data.sale_mode || 'catalog')
  if (data.company_name) {
    setCompanyName(data.company_name)
  }
}

export function getCompanyName() {
  return String(localStorage.getItem('company_name') || '').trim()
}

export function setCompanyName(name) {
  const value = String(name || '').trim()
  if (value) localStorage.setItem('company_name', value)
}
